module.exports = __webpack_public_path__ + "static/media/code.67a0a393.svg";